﻿import { RequestEvent } from 'common/event';
import { Permission } from 'shared/metadata/permissionset';

export class User {
    constructor(
        public userId: string,
        public username: string,
        public firstName: string,
        public lastName: string,
        public displayName: string,
        public email: string,
        public active: boolean,
        public system: boolean,
        public culture: string,
        public versionId: string
    ) { }
}

export class UserSearchOptions {
    constructor(
        public username: string,
        public firstName: string,
        public lastName: string,
        public displayName: string,
        public email: string,
        public active: boolean,
        public explicitPermission: string,
        public effectivePermission: string,
        public propertyName: string,
        public propertyValue: string
    ) { }
}

export class UserSearchRequested extends RequestEvent<UserSearchRequested, UserSearchResults> {
    constructor(public options: UserSearchOptions) {
        super();
    }
}

export class UserProperty {
    constructor(
        public property: string,
        public value: string,
        public validFrom: string,
        public validTo: string,
        public userPropertyCalculatorId: string
    ) { }
}

export class UserExplicitPropertiesRequested extends RequestEvent<UserExplicitPropertiesRequested, UserProperty[]> {
    constructor(public userId: string) {
        super();
    }
}

export class UserEffectivePropertiesRequested extends RequestEvent<UserEffectivePropertiesRequested, UserProperty[]> {
    constructor(public userId: string) {
        super();
    }
}

export class UserExplicitPermissionsRequested extends RequestEvent<UserExplicitPermissionsRequested, Permission[]> {
    constructor(public userId: string) {
        super();
    }
}

export class UserEffectivePermissionsRequested extends RequestEvent<UserEffectivePermissionsRequested, Permission[]> {
    constructor(public userId: string) {
        super();
    }
}

export class UserSaveDetails {
    constructor(
        public user: User,
        public properties: UserProperty[],
        public permissions: Permission[]
    ) { }
}

export class UserSaveRequested extends RequestEvent<UserSaveRequested, void> {
    constructor(public details: UserSaveDetails) {
        super();
    }
}

export class UserSearchResults {
    constructor(
        public results: User[],
        public resultLimit: number,
        public resultsLimited: boolean
    ) { }
}